import { render, staticRenderFns } from "./cooperatein.vue?vue&type=template&id=2a20dca9&scoped=true&"
import script from "./cooperatein.vue?vue&type=script&lang=js&"
export * from "./cooperatein.vue?vue&type=script&lang=js&"
import style0 from "./cooperatein.vue?vue&type=style&index=0&id=2a20dca9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a20dca9",
  null
  
)

export default component.exports